<ion-header>
    <ion-toolbar>
      <ion-title>Select Language</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="close()"> <ion-icon slot="icon-only" name="close-outline"></ion-icon> 
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  
  <ion-content>
    <ion-searchbar
      [(ngModel)]="searchText"
      (ionInput)="filterLanguages()"
      placeholder="Search language">
    </ion-searchbar>
  
    <ion-list>
      <ion-item
        button
        *ngFor="let lang of filteredLanguages"
        (click)="selectLanguage(lang)">
        {{ lang.name }}
      </ion-item>
    </ion-list>
  </ion-content>
  